<template>
  <div class="page-wrapper">
    <main-navigation></main-navigation>

    <div class="add-billing-container">

      <div class="form-card">

        <div class="form-header">
          <div class="form-icon">
            <i class="bi bi-receipt"></i>
          </div>
          <div>
            <h4>Add Tenant Bill</h4>
            <p>Create manual bill for tenant</p>
          </div>
        </div>

        <form @submit.prevent="saveBilling">

          <div class="form-grid">

            <!-- TENANT ID -->
            <div class="form-field">
              <label class="field-label">
                <i class="bi bi-person"></i>
                Tenant ID
              </label>
              <input
                v-model="billing.tenant_id"
                class="form-input"
                placeholder="Enter tenant id"
                required
              />
            </div>

            <!-- HOUSE ID -->
            <div class="form-field">
              <label class="field-label">
                <i class="bi bi-house"></i>
                House ID
              </label>
              <input
                v-model="billing.house_id"
                class="form-input"
                placeholder="Enter house id"
                required
              />
            </div>

            <!-- BILL NAME -->
            <div class="form-field">
              <label class="field-label">
                <i class="bi bi-tag"></i>
                Bill Name
              </label>
              <select v-model="billing.bill_name" class="form-select" required>
                <option value="">Select bill</option>
                <option value="Water">Water</option>
                <option value="Electricity">Electricity</option>
                <option value="Garbage">Garbage</option>
                <option value="Maintenance">Maintenance</option>
              </select>
            </div>

            <!-- AMOUNT -->
            <div class="form-field">
              <label class="field-label">
                <i class="bi bi-cash-stack"></i>
                Amount
              </label>
              <input
                v-model="billing.amount"
                type="number"
                class="form-input"
                placeholder="Enter amount"
                required
              />
            </div>

          </div>

          <div class="form-actions">
            <button class="btn-save-bill" type="submit">
              <i class="bi bi-check-lg"></i>
              Save Bill
            </button>

            <button
              type="button"
              class="btn-clear-secondary"
              @click="clearForm"
            >
              Clear
            </button>
          </div>

        </form>

      </div>

    </div>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
  data() {
    return {
      billing: {
        tenant_id: "",
        house_id: "",
        bill_name: "",
        amount: ""
      }
    };
  },

  methods: {

    async saveBilling() {

      try {

        if (
          !this.billing.tenant_id ||
          !this.billing.house_id ||
          !this.billing.bill_name ||
          !this.billing.amount
        ) {
          this.showToast("warning", "Fill all required fields");
          return;
        }

        const res = await apiFetch("/new/billing", {
          method: "POST",
          body: JSON.stringify(this.billing)
        });

        if (res.success === false) {
          throw new Error(res.message || "Failed to create bill");
        }

        this.showToast("success", "Bill created successfully");

        this.clearForm();

        this.$router.push("/billing");

      } catch (err) {

        console.error("Billing error:", err);

        this.showToast("error", err.message || "Failed to create billing");

      }

    },

    clearForm() {
      this.billing = {
        tenant_id: "",
        house_id: "",
        bill_name: "",
        amount: ""
      };
    },

    showToast(type, message) {
      alert(`${type.toUpperCase()}: ${message}`);
    }

  }
};
</script>

<style scoped>

.add-billing-container{
  display:flex;
  justify-content:center;
  padding:30px;
}

.form-card{
  background:white;
  border-radius: var(--dash-radius-lg);
  padding:30px;
  width:600px;
  box-shadow:0 20px 60px rgba(0,0,0,0.1);
}

.form-header{
  display:flex;
  align-items:center;
  gap:15px;
  margin-bottom:25px;
}

.form-icon{
  width:50px;
  height:50px;
  background: var(--dash-primary-soft);
  border-radius: var(--dash-radius);
  display:flex;
  align-items:center;
  justify-content:center;
  color: var(--dash-primary-ink);
}

.form-icon i{
  font-size:24px;
  color: var(--dash-primary-ink);
}

.form-grid{
  display:grid;
  grid-template-columns:repeat(2,1fr);
  gap:20px;
  margin-bottom:25px;
}

.form-field{
  display:flex;
  flex-direction:column;
}

.field-label{
  font-size:14px;
  font-weight:600;
  margin-bottom:8px;
  display:flex;
  align-items:center;
  gap:6px;
}

.form-input,
.form-select{
  padding:12px;
  border:2px solid var(--dash-line);
  border-radius: var(--dash-radius);
  background:var(--dash-surface-2);
}

.form-actions{
  display:flex;
  gap:12px;
}

.btn-save-bill{
  flex:1;
  background: var(--dash-primary);
  color:white;
  border:none;
  padding:14px;
  border-radius: var(--dash-pill);
  font-weight:700;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
}

.btn-clear-secondary{
  background:var(--dash-line);
  border:none;
  padding:14px 20px;
  border-radius: var(--dash-pill);
}

</style>